import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function WalkInFreezerIcon(props) {
	return (
		<IconBase type="walk-in-freezer" {...props}>
			<path d="M6 2H15V4H21V22H12V7H6V22H3V4H6V2ZM18.499 9.45L19.471 8.478L19.048 8.052L17.65 9.45H17.05V8.85L18.448 7.452L18.022 7.029L17.05 8.001V6.75H16.45V8.001L15.478 7.029L15.052 7.452L16.45 8.85V9.45H15.85L14.452 8.052L14.029 8.478L15.001 9.45H13.75V10.05H15.001L14.029 11.022L14.452 11.448L15.85 10.05H16.45V10.65L15.052 12.048L15.478 12.471L16.45 11.499V12.75H17.05V11.499L18.022 12.471L18.448 12.048L17.05 10.65V10.05H17.65L19.048 11.448L19.471 11.022L18.499 10.05H19.75V9.45H18.499Z" />
			<path d="M11.1 14.5H9.29999V15.5H11.1V14.5Z" />
		</IconBase>
	);
}
WalkInFreezerIcon.propTypes = iconPropTypes;
